$(function() {
  
  
  
    $('.list-faq dt').on('click', function() {
      $(this).toggleClass('open');
      $(this).next('dd').slideToggle();
    });

    
    $('.list-product-detail dt').on('click', function() {
          $(this).toggleClass('open');
          $(this).next('dd').slideToggle();
        });

    $('.list-faq-detail dt').on('click', function() {
          $(this).toggleClass('open');
          $(this).next('dd').slideToggle();
        });
      
});



